<template>
  <div class="board_wrap">
    <div class="board_title">
      <h1>ERP 시스템</h1>
    </div>
    <div class="product">
      <div>
        <h1>상자 관리 시스템</h1>
        &middot; &nbsp; 상자 생산 기업용 ERP 시스템
        <br />
        지함, 골판지, 상자, 포장지 등 생산, 제조업종 특화 시스템으로 생산, 구매, 회계 등 정보를 관리 할 수 있습니다.
      </div>
      <div>
        <h1>상자 관리 시스템 기능</h1>
        <FormTable :info="info"></FormTable>
      </div>
    </div>
  </div>
</template>

<script>
import FormTable from '../../static/FormTable.vue'
export default {
  components: { FormTable },
  data() {
    return {
      info: [
        {
          subject: '기초정보',
          element:
            '사용자 업체정보 관리, 공통코드 관리, 거래처 등록, 납품처 코드, 품목등록 관리, 제품 마스터 리스트, 기초 잔액 등록, 단가 관리, 운반비 관리, 설비코드, 거래처 여신 등록, 인쇄 양식 설정,사용자 암호 관리, 책임자 마감 작업, 업데이트, 자료 백업 등',
        },
        {
          subject: '판매관리',
          element: '상자 수주 등록, 상자 수주 현황,생산 진행 현황,제품 정보 조회,상자 재고 현황,출하 계힉 등록,상자 거래 명세서,상자 매출 현황,공급단가 분석표',
        },
        {
          subject: '구매관리',
          element: '원단 발주 등록, 기타 발주 등록, 원단 입고 등록, 기타 입고 등록, 발주 입고 현황, 부자재 입고등록, 부자재 입고현황, 부자재 마스터, 기성품 재고 현황',
        },
        {
          subject: '생산관리',
          element: '생산 계획 수립, 생산 실적 등록, 작업 대기 현황, 생산 대기 현황, 상자 생산 현황',
        },
        {
          subject: '재고관리',
          element: '상자 재고 현황, 상자 수불 현황, 조판목형관리대장',
        },
        {
          subject: '영업관리',
          element: '매출 입금 등록, 매출 입금 현황,상자 수주 현황,상자 매출 현황, 매출 거래처 원장, 외상 매출금 현황, 영어기획, 매출단가 검토표',
        },
        {
          subject: '마감관리',
          element: '매입 마감 확정, 매입 마감 현황, 매출 마감 확정,전자 세금계산서 발행,매출 세금계산서 등록,상자 운반비 마감 ,운반비 현황',
        },
        {
          subject: '기타',
          element: '공지사항, SMS 관리',
        },
      ],
    }
  },
}
</script>

<style scoped>
@import '../../../style/content.css';
.product div img {
  margin: 0 250px;
  width: 530px;
  height: 500px;
}
@media (max-width: 960px) {
  .product div img {
    margin: 0 180px;
  }
}
</style>
